/**
 * Filters empty strings and empty arrays to undefined so axios omits them from query params.
 * This restores the original URLSearchParams behavior where `if (x) { params.append(...) }`
 * prevented empty values from being sent.
 */
export const nonEmpty = <T extends string | unknown[]>(value: T | undefined | null): T | undefined => {
    return value?.length ? (value as T) : undefined;
};
